module.exports = __webpack_public_path__ + "img/Slide20.bc098f7c.png";